// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import useOnlineStatus from "./utils/hooks/useOnlineStatus";
// import { useSelector } from "react-redux";

// const Header = () => {
//   const [auth, setAuth] = useState("Login");
//   const onlineStatus = useOnlineStatus();

//   const cartItems = useSelector((store) => store.cart.items);

//   const handleAuth = () => {
//     auth === "Login" ? setAuth("Logout") : setAuth("Login");
//   };

//   return (
//     <div className="flex items-center justify-between bg-white shadow-sm rounded-b-lg border-b-2 text-slate-950 border-slate-950 w-full z-10 sticky">
//       <div className="flex items-center justify-start ">
//         <img
//           src="https://static.vecteezy.com/system/resources/previews/002/285/943/non_2x/food-service-logo-design-template-free-vector.jpg"
//           alt="logo"
//           className="w-20 ml-5 cursor-pointer"
//         />
//         <p className="font-serif cursor-pointer">YUMIO</p>
//       </div>
//       <div className="flex items-center justify-end gap-3">
//         <p className="mr-5 cursor-pointer text-decor">
//           Online Status: {onlineStatus ? "🟢" : "🔴 "}{" "}
//         </p>
//         <Link to="/">
//           <p className="mr-5 cursor-pointer text-decor">Home</p>
//         </Link>
//         <Link to="/about">
//           <p className="mr-5 cursor-pointer text-decor">About</p>
//         </Link>
//         <Link to="/cart">
//           <p className="mr-10 cursor-pointer text-decor">
//             Cart -{cartItems.length}
//           </p>
//         </Link>
//         <button
//           className="bg-slate-900 text-decor px-3 py-1  mr-10 cursor-pointer text-white rounded-full hover:bg-slate-700"
//           onClick={handleAuth}
//         >
//           {auth}
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Header;

import React, { useState } from "react";
import { Link } from "react-router-dom";
import useOnlineStatus from "./utils/hooks/useOnlineStatus";
import { useSelector } from "react-redux";
import MenuIcon from "@mui/icons-material/Menu"; // Assuming you are using Material Icons
import CloseIcon from "@mui/icons-material/Close";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

const Header = () => {
  const [auth, setAuth] = useState("Login");
  const onlineStatus = useOnlineStatus();
  const cartItems = useSelector((store) => store.cart.items);
  const [menuOpen, setMenuOpen] = useState(false);

  const handleAuth = () => {
    auth === "Login" ? setAuth("Logout") : setAuth("Login");
  };

  return (
    <div className="flex items-center justify-between bg-white shadow-sm rounded-b-lg border-b-2 text-slate-950 border-slate-950 w-full z-10 sticky top-0">
      {/* Left Side */}
      <div className="flex items-center justify-start ">
        <img
          src="https://static.vecteezy.com/system/resources/previews/002/285/943/non_2x/food-service-logo-design-template-free-vector.jpg"
          alt="logo"
          className="w-20 ml-5 cursor-pointer"
        />
        <p className="font-serif cursor-pointer">YUMIO</p>
      </div>

      {/* Right Side for larger screens */}
      <div className="hidden md:flex items-center justify-end gap-3">
        <p className="mr-5 cursor-pointer text-decor">
          Online Status: {onlineStatus ? "🟢" : "🔴 "}
        </p>
        <Link to="/">
          <p className="mr-5 cursor-pointer text-decor">Home</p>
        </Link>
        <Link to="/about">
          <p className="mr-5 cursor-pointer text-decor">About</p>
        </Link>
        <Link to="/cart">
          <p className="mr-10 cursor-pointer text-decor">
            <ShoppingCartIcon /> {cartItems.length}
          </p>
        </Link>
        <button
          className="bg-slate-900 text-decor px-3 py-1 mr-10 cursor-pointer text-white rounded-full hover:bg-slate-700"
          onClick={handleAuth}
        >
          {auth}
        </button>
      </div>

      {/* Hamburger Menu for smaller screens */}
      <div className="md:hidden flex items-center mr-5">
        <button onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? (
            <CloseIcon fontSize="large" />
          ) : (
            <MenuIcon fontSize="large" />
          )}
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="absolute top-16 right-0 bg-white shadow-lg rounded-lg p-4 w-3/4">
          <p className="mb-4 cursor-pointer text-decor">
            Online Status: {onlineStatus ? "🟢" : "🔴 "}
          </p>
          <Link to="/">
            <p className="mb-4 cursor-pointer text-decor">Home</p>
          </Link>
          <Link to="/about">
            <p className="mb-4 cursor-pointer text-decor">About</p>
          </Link>
          <Link to="/cart">
            <p className="mb-4 cursor-pointer text-decor">
              <ShoppingCartIcon /> {cartItems.length}
            </p>
          </Link>
          <button
            className="bg-slate-900 text-decor px-3 py-1 w-full text-white rounded-full hover:bg-slate-700"
            onClick={handleAuth}
          >
            {auth}
          </button>
        </div>
      )}
    </div>
  );
};

export default Header;
